module.exports = __webpack_public_path__ + "static/media/icon_wsp_white.7355b68a.svg";